export type CreationPayload = Record<string, unknown>;

export type InitialPayload = CreationPayload | null | undefined;

export const readString = (payload: InitialPayload, key: string, fallback = ''): string => {
  const value = payload?.[key];
  return typeof value === 'string' ? value : fallback;
};

export const readOption = <T extends string>(payload: InitialPayload, key: string, options: readonly T[], fallback: T): T => {
  const value = payload?.[key];
  return options.find(option => option === value) ?? fallback;
};

export const readArray = <T>(payload: InitialPayload, key: string): T[] => {
  const value = payload?.[key];
  return Array.isArray(value) ? (value as T[]) : [];
};
